(function () {
  "use strict";

  var data = window.__BRAND__ || {};
  var $  = function (sel, scope) { return (scope || document).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  var reduced   = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fineHover = matchMedia("(hover: hover) and (pointer: fine)").matches;

  function escHTML(s) {
    return String(s == null ? "" : s).replace(/[&<>\"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '\"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function safe(fn, name) { try { fn(); } catch (e) { console.warn("[" + name + "]", e); } }
  function clamp(v, min, max) { return v < min ? min : (v > max ? max : v); }

  function initNav() {
    var nav = $("[data-nav]");
    var bar = $("[data-progress]");
    if (!nav) return;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      nav.classList.toggle("is-stuck", y > 24);
      if (bar) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.setProperty("--progress", max > 0 ? clamp(y / max, 0, 1) : 0);
      }
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initMenu() {
    var burger = $("[data-burger]");
    var menu   = $("[data-menu]");
    if (!burger || !menu) return;
    function close() {
      burger.classList.remove("is-open");
      burger.setAttribute("aria-expanded", "false");
      burger.setAttribute("aria-label", "Abrir men\u00fa");
      menu.classList.remove("is-open");
      document.body.style.overflow = "";
      setTimeout(function () { if (!menu.classList.contains("is-open")) menu.hidden = true; }, 400);
    }
    function open() {
      menu.hidden = false;
      requestAnimationFrame(function () { menu.classList.add("is-open"); });
      burger.classList.add("is-open");
      burger.setAttribute("aria-expanded", "true");
      burger.setAttribute("aria-label", "Cerrar men\u00fa");
      document.body.style.overflow = "hidden";
    }
    burger.addEventListener("click", function () {
      if (menu.classList.contains("is-open")) close(); else open();
    });
    menu.addEventListener("click", function (e) { if (e.target.closest("a")) close(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.classList.contains("is-open")) close();
    });
  }

  function initSmoothScroll() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 84,
        behavior: reduced ? "auto" : "smooth"
      });
    });
  }

  function initReveals() {
    var plain = $$(".reveal:not([data-split])");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add("is-visible");
        io.unobserve(en.target);
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -4% 0px" });
    plain.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 6, 5) * 70) + "ms";
      io.observe(el);
    });
    setTimeout(function () {
      $$(".reveal:not(.is-visible)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.add("is-visible");
      });
      $$("[data-split]:not(.is-in)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.add("is-in");
      });
    }, 6000);
  }

  function splitEl(el, mode) {
    var wrap = function (text) {
      return text.split(/(\s+)/).map(function (w) {
        if (/^\s*$/.test(w)) return w;
        if (mode === "chars") {
          return '<span class="split-word">' + w.split("").map(function (c) {
            return '<span class="split-char">' + escHTML(c) + "</span>";
          }).join("") + "</span>";
        }
        return '<span class="split-word">' + escHTML(w) + "</span>";
      }).join("");
    };
    var html = Array.prototype.slice.call(el.childNodes).map(function (node) {
      if (node.nodeType === 3) return wrap(node.textContent);
      if (node.nodeName === "BR") return "<br>";
      if (node.nodeType === 1) {
        var tag = node.tagName.toLowerCase();
        var cls = node.getAttribute("class");
        return "<" + tag + (cls ? ' class="' + escHTML(cls) + '"' : "") + ">" + wrap(node.textContent) + "</" + tag + ">";
      }
      return "";
    }).join("");
    el.setAttribute("aria-label", el.textContent.trim().replace(/\s+/g, " "));
    el.innerHTML = '<span aria-hidden="true">' + html + "</span>";
  }

  function initSplitText() {
    var targets = $$("[data-split]");
    if (!targets.length) return;
    targets.forEach(function (el) {
      var mode = el.getAttribute("data-split") === "chars" ? "chars" : "words";
      splitEl(el, mode);
      var pieces = $$(mode === "chars" ? ".split-char" : ".split-word", el);
      var step = mode === "chars" ? 16 : 55;
      pieces.forEach(function (p, i) { p.style.transitionDelay = (i * step) + "ms"; });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add("is-in");
        io.unobserve(en.target);
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -4% 0px" });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initHeroMotion() {
    var hero  = $("[data-hero]");
    var stage = $(".hero-stage");
    if (!hero) return;
    var items = stage ? $$("[data-depth]", stage) : [];
    var tx = 62, ty = 38, cx = 62, cy = 38;
    var mxTarget = 0, myTarget = 0, mx = 0, my = 0;
    var scrollY = 0;
    var running = false;
    if (fineHover) {
      hero.addEventListener("pointermove", function (e) {
        var r = hero.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width) * 100;
        ty = ((e.clientY - r.top) / r.height) * 100;
        mxTarget = (e.clientX - r.left) / r.width - 0.5;
        myTarget = (e.clientY - r.top) / r.height - 0.5;
        start();
      }, { passive: true });
    }
    window.addEventListener("scroll", function () {
      scrollY = window.scrollY || window.pageYOffset;
      start();
    }, { passive: true });
    function start() { if (!running) { running = true; requestAnimationFrame(loop); } }
    function loop() {
      cx += (tx - cx) * 0.07;
      cy += (ty - cy) * 0.07;
      mx += (mxTarget - mx) * 0.07;
      my += (myTarget - my) * 0.07;
      hero.style.setProperty("--mx", cx.toFixed(2) + "%");
      hero.style.setProperty("--my", cy.toFixed(2) + "%");
      var progress = clamp(scrollY / Math.max(window.innerHeight, 1), 0, 1);
      items.forEach(function (item) {
        var d = parseFloat(item.getAttribute("data-depth")) || 10;
        item.style.setProperty("--px", (mx * d).toFixed(2) + "px");
        item.style.setProperty("--py", (my * d * 0.7 - progress * d * 1.9).toFixed(2) + "px");
      });
      var moving = Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05 ||
                   Math.abs(mxTarget - mx) > 0.001 || Math.abs(myTarget - my) > 0.001;
      if (moving) requestAnimationFrame(loop); else running = false;
    }
    loop();
  }

  function initCardGlow() {
    if (!fineHover) return;
    $$("[data-glow]").forEach(function (card) {
      if (card.dataset.glowBound) return;
      card.dataset.glowBound = "1";
      card.addEventListener("pointermove", function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty("--gx", (((e.clientX - r.left) / r.width) * 100).toFixed(1) + "%");
        card.style.setProperty("--gy", (((e.clientY - r.top) / r.height) * 100).toFixed(1) + "%");
      }, { passive: true });
    });
  }

  function initCounters() {
    var els = $$("[data-count]");
    if (!els.length) return;
    function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute("data-count")) || 0;
        var dur = 1500, t0 = null;
        function tick(t) {
          if (t0 === null) t0 = t;
          var p = clamp((t - t0) / dur, 0, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(Math.round(target * eased));
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    var items = $$(".faq-item");
    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function initBuyBar() {
    var bar  = $("[data-buybar]");
    var hero = $("[data-hero]");
    if (!bar || !hero) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle("is-visible", !en.isIntersecting); });
    }, { threshold: 0, rootMargin: "-40% 0px 0px 0px" });
    io.observe(hero);
  }

  function initCheckout() {
    var map = data.checkout || {};
    $$("[data-checkout]").forEach(function (el) {
      var key = el.getAttribute("data-checkout");
      var url = map[key];
      if (url) { el.setAttribute("href", url); }
    });
  }

  function initYear() {
    var el = $("[data-year]");
    if (el) el.textContent = new Date().getFullYear();
  }

  function initScrollParallax() {
    gsap.utils.toArray(".brand-glow, .closing-glow").forEach(function (el) {
      gsap.fromTo(el, { yPercent: -6 }, {
        yPercent: 6, ease: "none",
        scrollTrigger: { trigger: el.parentElement, start: "top bottom", end: "bottom top", scrub: 0.6 }
      });
    });
    gsap.utils.toArray(".marquee-track").forEach(function (track) {
      gsap.fromTo(track, { xPercent: 0 }, {
        xPercent: -6, ease: "none",
        scrollTrigger: { trigger: track.parentElement, start: "top bottom", end: "bottom top", scrub: 1 }
      });
    });
  }

  function boot() {
    safe(initNav, "initNav");
    safe(initMenu, "initMenu");
    safe(initSmoothScroll, "initSmoothScroll");
    safe(initSplitText, "initSplitText");
    safe(initReveals, "initReveals");
    safe(initHeroMotion, "initHeroMotion");
    safe(initCardGlow, "initCardGlow");
    safe(initCounters, "initCounters");
    safe(initFaq, "initFaq");
    safe(initBuyBar, "initBuyBar");
    safe(initCheckout, "initCheckout");
    safe(initYear, "initYear");
    if (window.gsap && window.ScrollTrigger) {
      try { gsap.registerPlugin(ScrollTrigger); } catch (e) {}
      safe(initScrollParallax, "initScrollParallax");
    }
    document.documentElement.classList.add("is-ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
